import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import CustomSelect from '../../../CustomReactSelectComponent'
import InputGroup from '../../../InputGroup'
import PhoneNumber from '../../../CustomNumberFormat'
import Switcher from '../../../CustomSwitchComponent'
import { Row, Col, Button, Form } from 'reactstrap'
import { MERCHANT_FILTERS } from '../../../../constants/contactFilterCategory'

const FilterInputsMerchant = ({
  selectedFilters,
  handleFiltersChanges,
  loadData,
  selectedFiltersValues,
  getOptions,
  options,
}) => {
  useEffect(() => {
    getOptions(MERCHANT_FILTERS)
  }, [])

  return (
    <>
      <Form noValidate onSubmit={() => loadData()}>
        <Row className='mt-3 filterInputs'>
          {selectedFilters.name && (
            <Col xs={3}>
              <InputGroup
                label='Name'
                type='text'
                name='name'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.name}
              />
            </Col>
          )}
          {selectedFilters.owner_name && (
            <Col xs={3}>
              <InputGroup
                label='Company Owner'
                type='text'
                name='owner_name'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.owner_name}
              />
            </Col>
          )}
          {selectedFilters.merchant_type && (
            <Col xs={3}>
              <CustomSelect
                label='Merchant Type'
                defaultValue={selectedFiltersValues.merchant_type}
                onChange={(event) => handleFiltersChanges(event, 'select', 'merchant_type')}
                isMulti={false}
                options={[]}
              />
            </Col>
          )}
          {selectedFilters.address_state && (
            <Col xs={3}>
              <CustomSelect
                label='State'
                defaultValue={selectedFiltersValues.address_state}
                onChange={(event) => handleFiltersChanges(event, 'select', 'address_state')}
                isMulti={false}
                options={options.States || []}
              />
            </Col>
          )}
          {selectedFilters.estimated_revenue && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Est. revenue from'
                  name='estimated_revenue'
                  type='number'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.estimated_revenue && selectedFiltersValues.estimated_revenue.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Est. revenue to'
                  name='estimated_revenue'
                  type='number'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.estimated_revenue && selectedFiltersValues.estimated_revenue.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.date_established && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Date Established from'
                  name='date_established'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.date_established && selectedFiltersValues.date_established.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Date Established to'
                  name='date_established'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.date_established && selectedFiltersValues.date_established.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.created_by && (
            <Col xs={3}>
              <CustomSelect
                label='Entered By'
                defaultValue={selectedFiltersValues.created_by}
                onChange={(event) => handleFiltersChanges(event, 'select', 'created_by')}
                isMulti={false}
                options={options.Users || []}
              />
            </Col>
          )}
          {selectedFilters['divisions.division_id'] && (
            <Col xs={3}>
              <CustomSelect
                label='Divisions Account'
                defaultValue={selectedFiltersValues['divisions.division_id']}
                onChange={(event) => handleFiltersChanges(event, 'select', 'divisions.division_id')}
                isMulti={false}
                options={options.Divisions || []}
              />
            </Col>
          )}
          {selectedFilters.email && (
            <Col xs={3}>
              <InputGroup
                label='Email'
                type='text'
                name='email'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.email}
              />
            </Col>
          )}
          {selectedFilters.business_phone && (
            <Col xs={3}>
              <PhoneNumber
                label='Business Phone'
                className={'form-control-sm form-control'}
                name='business_phone'
                value={selectedFiltersValues.business_phone}
                placeholder='Business Phone'
                type='tel'
                format='(999) 999-9999'
                onChange={handleFiltersChanges}
                size={10}
                hidePhoneIcon
              />
            </Col>
          )}
          {selectedFilters.source_id && (
            <Col xs={3}>
              <CustomSelect
                label='Source'
                defaultValue={selectedFiltersValues.source_id}
                onChange={(event) => handleFiltersChanges(event, 'select', 'source_id')}
                isMulti={false}
                options={options.SourceType || []}
              />
            </Col>
          )}
          {selectedFilters.address_zip && (
            <Col xs={3}>
              <InputGroup
                label='Zip Code'
                type='text'
                name='address_zip'
                onChange={(event) => handleFiltersChanges(event)}
                value={selectedFiltersValues.address_zip}
              />
            </Col>
          )}
          {selectedFilters['divisions.grade'] && (
            <Col xs={3}>
              <CustomSelect
                label='Grade'
                defaultValue={selectedFiltersValues['divisions.grade']}
                onChange={(event) => handleFiltersChanges(event, 'select', 'divisions.grade')}
                isMulti={false}
                options={options.ProspectGrade || []}
              />
            </Col>
          )}
          {selectedFilters.merchant && (
            <Col xs={3}>
              <CustomSelect
                label='Merchant'
                defaultValue={selectedFiltersValues.merchant}
                onChange={(event) => handleFiltersChanges(event, 'select', 'merchant')}
                isMulti={false}
                options={[]} // NEED Merchant
              />
            </Col>
          )}
          {selectedFilters.import_date && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Import Date from'
                  name='import_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.import_date && selectedFiltersValues.import_date.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Import Date to'
                  name='import_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.import_date && selectedFiltersValues.import_date.to}
                />
              </Col>
            </>
          )}
          {selectedFilters.creation_date && (
            <>
              <Col xs={2}>
                <InputGroup
                  label='Date Entered from'
                  name='creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.creation_date && selectedFiltersValues.creation_date.from}
                />
              </Col>
              <Col xs={2}>
                <InputGroup
                  label='Date Entered to'
                  name='creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.creation_date && selectedFiltersValues.creation_date.to}
                />
              </Col>
            </>
          )}
          {selectedFilters['divisions.assigned'] && (
            <Col xs={3}>
              <CustomSelect
                label='Salesperson'
                defaultValue={selectedFiltersValues['divisions.assigned']}
                onChange={(event) => handleFiltersChanges(event, 'select', 'divisions.assigned')}
                isMulti={false}
                options={options.Salespersons || []}
              />
            </Col>
          )}
          {selectedFilters.out_of_business && (
            <Col xs={3}>
              <Switcher
                labelName='Out Of Bussines'
                name='out_of_business'
                checked={selectedFiltersValues.out_of_business}
                onChange={(event) => handleFiltersChanges(event)}
              />
            </Col>
          )}
        </Row>
      </Form>
      <Row className='flex-row-reverse mr-3'>
        <Button className={'btn btn-gold'} type='submit' onClick={() => loadData()}>
          Search
        </Button>
      </Row>
    </>
  )
}

FilterInputsMerchant.propTypes = {
  selectedFilters: PropTypes.object.isRequired,
  selectedFiltersValues: PropTypes.object,
  handleFiltersChanges: PropTypes.object.isRequired,
  loadData: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  getOptions: PropTypes.func.isRequired,
}

FilterInputsMerchant.defaultProps = {
  selectedFiltersValues: {},
}

export default FilterInputsMerchant
